import apiClient from "../../../utilities/apiClient";

export const createDocRequest = (payload) => {
  return apiClient.post(apiClient.Urls.createDocRequest, payload, true);
};

export const getAdminDocRequests = (params) => {
  const query = params?.search ? `?search=${encodeURIComponent(params.search)}` : "";
  return apiClient.get(`${apiClient.Urls.getAdminDocRequests}${query}`, "", true);
};

export const getAdminDocRequestDetails = (id) => {
  return apiClient.get(`${apiClient.Urls.getAdminDocRequestDetails}/${id}`, "", true);
};

export const getVendorDocRequests = () => {
  return apiClient.get(apiClient.Urls.getVendorDocRequests, "", true);
};

export const getAdminVendorDocRequests = (vendorId) => {
  return apiClient.get(`${apiClient.Urls.getAdminVendorDocRequests}/${vendorId}`, "", true);
};

export const uploadVendorDoc = (payload) => {
  const isFile = payload instanceof FormData;
  return apiClient.post(apiClient.Urls.uploadVendorDoc, payload, true, isFile ? "file" : undefined);
};

export const reviewVendorDoc = (payload) => {
  return apiClient.post(apiClient.Urls.reviewVendorDoc, payload, true);
};

export const addVendorsToDocRequest = (id, payload) => {
  return apiClient.post(`${apiClient.Urls.getAdminDocRequestDetails}/${id}/add-vendors`, payload, true);
};

export const getVendorsList = () => {
  return apiClient.get(apiClient.Urls.vendors_list, "", true);
};
